<template>
  <div class="flex border-t flex-col mt-4 pt-4 space-y-2">
    <div class="text-sm" v-if="title">{{ title }}</div>
    <div class="text-sm" v-else>Favori Aramalar</div>
    <form @submit.prevent="favoriteFilterApply()">
      <select
        v-model="filter"
        @change="favoriteFilterApply()"
        class="uk-select"
      >
        <option value="">Seçiniz</option>
        <option :value="fl" v-for="fl in filters">
          {{ fl.name }}
        </option>
      </select>
    </form>
    <div
      v-if="filter"
      @click="removeFilter(filter.id)"
      class="global-button-xs text-red-400 cursor-pointer inline-flex w-40"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        class="h-4 w-4"
        viewBox="0 0 24 24"
      >
        <path
          fill="currentColor"
          d="M7 21q-.825 0-1.412-.587T5 19V6H4V4h5V3h6v1h5v2h-1v13q0 .825-.587 1.413T17 21zM17 6H7v13h10zM9 17h2V8H9zm4 0h2V8h-2zM7 6v13z"
        />
      </svg>
      <span>Seçili Filtreyi Sil</span>
    </div>
  </div>
</template>
<script>
import http from "../../services/http";
import EventBus from "../Ui/EventBus";
export default {
  data() {
    return {
      filters: [],
      filter: null,
    };
  },
  props: ["table", "title"],
  mounted() {
    EventBus.$on("reflesh", () => {
      this.getData();
    });
    this.getData();
  },
  methods: {
    removeFilter(id) {
      if (confirm("Bu işlem filtreyi crmden siler eminmisiniz ? ")) {
        http.removeFavoriteFilter(id).then(() => {
          this.getData();
        });
      }
    },
    favoriteFilterApply(data) {
      EventBus.$emit("favoriteFilterApply", this.filter.filters);
    },
    getData() {
      http
        .favoriFilters({
          table: this.table,
        })
        .then((e) => {
          this.filters = e.data.results;
          this.loading = false;
        });
    },
  },
};
</script>
